import { saveAs } from "file-saver";
import { Mixpanel } from "../../config/Mixpanel";
import constants from "../PersonaliseLessons/utilities/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import useWindowSize from "../../hooks/useWindowSize";

const CertificateDownload = ({
  courseProgress,
  certificateUrl,
  handleNavigation,
}) => {
  const { width } = useWindowSize();

  async function downloadCertificate(link) {
    const bytes = await fetch(link, {
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
      },
    })
      .then((res) => res.arrayBuffer())
      .catch((err) => console.log(err));

    saveAs(new Blob([bytes]), `Certificate.jpg`);
  }

  return (
    <div
      className="flex items-center rounded-xl"
      style={{
        background: "rgba(45, 79, 113, 0.37)",
      }}
    >
      <div
        className={`${
          courseProgress === 100
            ? "w-[125px]"
            : width <= 360
            ? "w-[130px]"
            : "w-[110px]"
        } h-full`}
      >
        <img
          src={
            courseProgress === 100
              ? certificateUrl
              : "https://img.learntube.ai/public-assets/Onboarding_Revamp/image-448%201.png?updatedAt=1696847392130"
          }
          alt=""
          width={99}
          height={69}
          className="h-full w-full rounded-tl-xl rounded-bl-xl"
        />
      </div>
      <div className="relative ml-2 flex-1 py-1.5 text-sm font-medium leading-normal text-white md:py-2">
        <div className="flex justify-between">
          <div className="flex items-center">
            {courseProgress === 100 ? (
              <div className="mr-1 grid h-4 w-4 place-content-center rounded-full bg-[#4CAF50]">
                <FontAwesomeIcon
                  icon={faCheck}
                  color="#fff"
                  className="text-sm"
                />
              </div>
            ) : (
              <div className="mr-2 h-4 w-4">
                <img
                  src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Vector.png?updatedAt=1696852250766"
                  alt=""
                  className="h-auto w-full object-cover"
                />
              </div>
            )}
            <p className="pt-1 text-sm font-medium">
              {courseProgress !== 100
                ? "Industry Verified Certification"
                : "Congratulations!"}
            </p>
          </div>
          {courseProgress === 100 ? (
            <div
              className="mr-1 flex cursor-pointer items-center rounded-[19px] bg-[#17304A] py-1.5 px-2"
              onClick={() => {
                Mixpanel.track(
                  constants.Mixpanel
                    .NEW_LEADERBOARD_PAGE_CERTIFICATE_WAS_DOWNLOADED,
                );
                downloadCertificate(certificateUrl);
              }}
            >
              <div className=" flex h-3 w-3 items-center justify-center rounded-full">
                <img
                  src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/download%201.svg?updatedAt=1692792258790"
                  alt=""
                />
              </div>
              <p className="ml-1 text-[10px] font-medium">Download</p>
            </div>
          ) : null}
        </div>
        {courseProgress !== 100 ? (
          <p className="mr-2 mt-1 text-xs font-medium text-white/50 md:mt-2">
            {" "}
            Complete all quizzes to finish the course & unlock your certificate.
            <img
              src="https://img.learntube.ai/public-assets/Lead%20Generation/Frame%2010637.png?updatedAt=1713343429369"
              width={16}
              height={16}
              alt=""
              className="inline cursor-pointer"
              onClick={handleNavigation}
            />
          </p>
        ) : (
          <p className="mr-2 mt-1 text-xs font-medium opacity-50 md:mt-2">
            Your certificate is unlocked! Add it to your CV & linkedin and grow
            your career.
          </p>
        )}
      </div>
    </div>
  );
};

export default CertificateDownload;
